import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import status from "../../assets/images/verifyVisit.png";

export default function UploadDownloadSatus() {
  return (
    <>
      <Card
        sx={{
          width: "100%",
          backgroundColor: "myVerify.light",
          boxShadow: " 0 16px #3E7787",
          marginBottom: 2,
        }}
      >
        <CardContent>
          <Grid container mt={1}>
            <Grid item xs={2} sm={2} md={1} sx={{ textAlign: "center" }}>
              <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
                <img src={status} alt="status" style={{ width: "70%" }} />
              </Box>
            </Grid>
            <Grid
              item
              xs={10}
              sm={10}
              md={11}
              display="block"
              flexDirection="column"
              paddingLeft={3}
            >
              <Typography variant="h6" fontWeight={700} marginBottom={1}>
                How to Upload and Download Documents and Images
              </Typography>
              <Typography marginBottom={1}>
                In this application you will be asked to upload specific
                documents, and you may wish to download others. This page will
                help you with both.
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
